// extracted by mini-css-extract-plugin
export default {"description":"default_description__cTE-j"};